import angular from 'angular';

function LoadingFeedback($rootScope, $q) {
	var setStatus = function (method, value) {
		if (method === 'POST') {
			$rootScope.loading = value;
		} else if (method === 'PUT') {
			$rootScope.loading = value;
		} else if (method !== 'GET') {
			$rootScope.loading = value;
		}
	};
	return {
		/*
		  For non-GET calls show the loading indicator
		 */
		request: function (config) {
			// loading indicator should not be visible for fact-related interactions
			// since fact view has it's own indicator
			if (!/fact/.test(config.url)) {
				setStatus(config.method, true);
			}
			return config;
		},
		response: function (response) {
			setStatus(response.config.method, false);
			return response || $q.when(response);
		},
		responseError: function (response) {
			setStatus(response.config.method, false);
			return $q.reject(response);
		}
	};
}
LoadingFeedback.$inject = ['$rootScope', '$q'];
export default angular.module('interceptors.loading-feedback', [])
	.factory('LoadingFeedback', LoadingFeedback)
	.name;



// WEBPACK FOOTER //
// ./project/interceptors/loading-feedback.js